import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import axios from "axios";
import {
  Modal,
  Upload,
  Image,
  ConfigProvider,
  message,
  UploadFile,
} from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { scaleUpload } from "@/services/data/patientSelfReported";
// import './photo.less';
import zh_CN from "antd/lib/locale-provider/zh_CN";
import {
  makeThumb,
  proxyFileUpload,
} from "../../../../../../crf_form/components/ocr-autofill/utils";

import ImageViewer from "../../../../../../crf_form/components/image-viewer";

function PhotoOssCom(props: any, ref: any) {
  const [previewVisible, setPreviewVisible] = useState<boolean>(false);
  const [previewTitle, setPreviewTitle] = useState<string>("");
  const [fileList, setFileList] = useState<any>([]);
  const [value, setValue] = useState<any>([]);
  const [data, setData] = useState<any>();
  const [previewImage, setPreviewImage] = useState<any>();

  useEffect(() => {
    if (props.data) {
      let fieldList = [];
      const urls = props.data.url;
      for (let i = 0; i < urls?.length; i++) {
        fieldList.push(makeThumb(urls[i]));
      }
      setValue(fieldList);
      setFileList(fieldList);
    } else {
      setValue([]);
      setFileList([]);
    }
  }, [props.data]);

  //图片预览
  const handlePreview = ({ url }: UploadFile) => {
    setPreviewImage(url);
    setPreviewVisible(true);
  };

  const handleChange = async ({ file }: any) => {
    if (!file) {
      return;
    }

    const [_, ext] = file.type.split("/");
    if (![".jpg", ".jpeg", ".png"].includes(`.${ext}`)) {
      message.error("上传格式不允许");
      return;
    }

    // 通过后端代理上传至OSS
    const uploadResult = await proxyFileUpload(file);

    if (!uploadResult) {
      message.error("上传失败，请重试！");
      return;
    }

    const url = uploadResult.url;
    if (url) {
      const thumbs = [...value, makeThumb(url)];
      setValue(thumbs);
      setFileList(thumbs);
    }
  };

  const uploadButton = (
    <div>
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>点击上传图片</div>
    </div>
  );

  const beforeUploadControl = (file: File) => {
    return file;
  };

  useImperativeHandle(ref, () => ({
    // 暴露给父组件的方法
    getModifyValue: () => {
      try {
        scaleUpload({
          id: props.data.id,
          url: fileList.map(({ url }: { url: string }) => url),
        });
      } catch (error) {
        console.error(error);
      }
    },
  }));

  const removeChange = (file: any) => {
    let _fileList = fileList.filter((v: any) => v.uid !== file.uid);
    setValue(_fileList);
    setFileList(_fileList);
  };

  return (
    <ConfigProvider locale={zh_CN}>
      <div className="photoCom">
        {
          <div>
            <Upload
              method="POST"
              accept=".jpg, .jpeg, .png"
              customRequest={handleChange}
              listType="picture-card"
              fileList={fileList}
              beforeUpload={beforeUploadControl}
              onPreview={handlePreview}
              onRemove={removeChange}
              maxCount={8}
            >
              {value.length >= 8 ? null : uploadButton}
            </Upload>
            <ImageViewer
              visible={previewVisible}
              urls={fileList.map(({ url }: { url: string }) => url)}
              url={previewImage}
              onClose={() => setPreviewVisible(false)}
            />
          </div>
        }
      </div>
    </ConfigProvider>
  );
}

export default forwardRef(PhotoOssCom);
